import React from "react";
import "./table.scss";
import { PropTypes } from "prop-types";

export const NewTable = ({ data, cols, legend }) => {
  return (
    <div className="table-datosContainer">
      <div className="table-datosScroll">
        <div className="table-wrapper">
          {data.length !== 0 && (
            <table>
              <thead>
                <tr>
                  {cols.map(col => (
                    <th key={col.label} className={col.classHead}>
                      {col.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {data
                  .filter(item => {
                    return true;
                  }) // TODO REVISAR
                  .map(item => (
                    <tr key={item.name || item.partyAcronym || item.id}>
                      {cols.map(col => (
                        <td
                          key={`${col.label}-${item.name}`}
                          className={col.classBody}
                        >
                          <span
                            style={
                              col.showColor
                                ? {
                                    borderLeft: `10px solid ${item.partyColor}`
                                  }
                                : {}
                            }
                          >
                            <span className="partido">
                              {col.map ? col.map(item[col.key]) : item[col.key]}
                            </span>
                          </span>
                        </td>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      {legend && <p className="table-datosLegend">{legend}</p>}
    </div>
  );
};

NewTable.propTypes = {
  data: PropTypes.array.isRequired,
  cols: PropTypes.array,
  legend: PropTypes.string
};

NewTable.defaultProps = {
  legend: "",
  cols: [
    {
      label: "",
      key: "partyAcronym",
      classHead: "partido",
      classBody: "dato-nombre-partido",
      showColor: true
    },
    {
      label: "% Votos",
      key: "votesPercent",
      classHead: "porcentaje",
      classBody: "dato-escanos",
      map: data => Number(data).toLocaleString("es")
    },
    {
      label: "Votos",
      key: "votes",
      classHead: "porcentaje",
      classBody: "dato-escanos",
      map: data => Number(data).toLocaleString("es")
    }
  ]
};

export default NewTable;
